import React, { useContext, useEffect } from 'react';
import { ReactComponent as PixChecked } from 'assets/svg/questionnaire-checked.svg';
import { useTranslation } from 'react-i18next';
import { useSwiperSlide } from 'swiper/react';
import { EndScreenWrapper } from 'pages/questionnaire/slides/end/QuestionnaireEnd.styled';
import { Container } from 'layout/page/Page.layout.styled';
import { useDeviceSelectors } from 'react-device-detect';
import QuestionnaireInstallApp from 'pages/questionnaire/slides/questionnaire-install-app/QuestionnaireInstallApp';
import { UserContext, UserContextProps } from 'contexts/UserContext';
import { setQuestionnaireEndPending } from 'helpers/utils';

export interface QuestionnaireEndProps {
  showTrimaCta?: boolean;
}

const QuestionnaireEnd: React.FC<QuestionnaireEndProps> = () => {
  const { t } = useTranslation('translation');
  const { user } = useContext(UserContext) as UserContextProps;
  const [selectors] = useDeviceSelectors(window.navigator.userAgent);
  const { isAndroid, isIOS } = selectors;
  // All slides are mounted at once: only flag the end screen as "pending"
  // once it is actually the active slide (null when rendered outside a swiper).
  const swiperSlide = useSwiperSlide() as ReturnType<typeof useSwiperSlide> | null;
  const isActive = swiperSlide ? swiperSlide.isActive : true;

  useEffect(() => {
    if (isActive) {
      setQuestionnaireEndPending(user?.id);
    }
  }, [isActive, user?.id]);

  return (
    <EndScreenWrapper>
      <Container className="main">
        <div className="pix-wrapper">
          <PixChecked />
        </div>
        <h3>{t('questionnaire.responses-saved')}</h3>
        <p>{t('questionnaire.final-message')}</p>
        <p className="install-intro">{t('questionnaire.install-app')}</p>
      </Container>
      <Container className="install-app">
        <QuestionnaireInstallApp isAndroid={isAndroid} isIOS={isIOS} />
      </Container>
    </EndScreenWrapper>
  );
};

export default QuestionnaireEnd;
